// Shared Google Maps styles for light and dark themes

export const lightMapStyles = [
  { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
  { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
  { featureType: 'administrative', elementType: 'geometry', stylers: [{ color: '#e0e0e0' }] },
  { featureType: 'administrative', elementType: 'labels.text.fill', stylers: [{ color: '#424242' }] },
  { featureType: 'landscape', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
  { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#eeeeee' }] },
  { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
  { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#e8f5e8' }] },
  { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
  { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#bdbdbd' }] },
  { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#424242' }] },
  { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#dadada' }] },
  { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#9e9e9e' }] },
  { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: '#f0f0f0' }] },
  { featureType: 'transit', elementType: 'geometry', stylers: [{ color: '#e0e0e0' }] },
  { featureType: 'transit', elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#c9c9c9' }] },
  { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] },
  { featureType: 'water', elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] }
];

export const darkMapStyles = [
  { elementType: 'geometry', stylers: [{ color: '#1a1a1a' }] },
  { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#d0d0d0' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#1a1a1a' }] },
  { featureType: 'administrative', elementType: 'geometry', stylers: [{ color: '#2a2a2a' }] },
  { featureType: 'administrative', elementType: 'labels.text.fill', stylers: [{ color: '#a0a0a0' }] },
  { featureType: 'landscape', elementType: 'geometry', stylers: [{ color: '#1a1a1a' }] },
  { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#252525' }] },
  { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#808080' }] },
  { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#2a2a2a' }] },
  { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#404040' }] },
  { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#1a1a1a' }] },
  { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#a0a0a0' }] },
  { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#505050' }] },
  { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#303030' }] },
  { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: '#404040' }] },
  { featureType: 'transit', elementType: 'geometry', stylers: [{ color: '#252525' }] },
  { featureType: 'transit', elementType: 'labels.text.fill', stylers: [{ color: '#606060' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#0a0a0a' }] },
  { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#505050' }] },
  { featureType: 'water', elementType: 'labels.text.stroke', stylers: [{ color: '#0a0a0a' }] }
];

// Helper to get map styles based on theme
export const getMapStyles = (isLightTheme: boolean) =>
  isLightTheme ? lightMapStyles : darkMapStyles;
